import React, { useEffect, useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Loader2 } from 'lucide-react';

const TallySurveyEmbed: React.FC = () => {
  const [url, setUrl] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchUrl = async () => {
      try {
        const { data, error } = await supabase.functions.invoke('get-tally-form-url');
        if (error) throw error;
        if (!data?.url) {
          setError('Tally form URL is not configured.');
        } else {
          setUrl(data.url);
        }
      } catch (err: any) {
        console.error('Failed to load Tally form URL', err);
        setError(err?.message || 'Failed to load Tally form URL');
      } finally {
        setLoading(false);
      }
    };
    fetchUrl();
  }, []);

  if (loading) {
    return (
      <div className="flex items-center justify-center py-8">
        <Loader2 className="h-5 w-5 animate-spin mr-2" />
        <span>Loading survey…</span>
      </div>
    );
  }

  if (error || !url) {
    return (
      <Card className="border-dashed">
        <CardHeader>
          <CardTitle>Healing Stage Survey</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-muted-foreground">{error || 'Survey not available at the moment.'}</p>
        </CardContent>
      </Card>
    );
  }

  return (
    <div className="w-full">
      <iframe
        src={url}
        title="Healing Stage Survey"
        loading="lazy"
        className="w-full rounded-lg border"
        style={{ minHeight: 640 }}
        allow="microphone; camera; clipboard-read; clipboard-write;"
        sandbox="allow-forms allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"
      />
    </div>
  );
};

export default TallySurveyEmbed;
